export const MARITAL_STATUS = Object.freeze([
    { value: '0', text: 'Single' },
    { value: '1', text: 'Married' },
    { value: '2', text: 'Divorced' },
    { value: '3', text: 'Widowed' },
]);